module.exports = __webpack_public_path__ + "media/images/home/cover-img-mobile-3a40ce6758c359e17c8313d8417c383c.jpg";